
import moment from "moment";
import { fetchConToken, fetchConTokenFiles } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { RECLAMOS_ESTADOS } from "../../utils/constants";

// Documentacion Efector
export const cleanDocumentacionReclamosExterno = () => ({ type: types.documentacionReclamosExternoClean });
export const errorDocumentacionReclamosExterno = () => ({ type: types.documentacionReclamosExternoError });
export const getDocumentacionReclamosExterno = (body) => ({ type: types.documentacionReclamosExternoSucces, payload: body });
export const postDocumentacionReclamosExterno = (body) => ({ type: types.documentacionReclamosExternoInsert, payload: body });
export const deleteDocumentacionReclamosExterno = (id) => ({ type: types.documentacionReclamosExternoEliminar, payload: id });

export const NuevoReclamoExterno = (datos) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const response = await fetchConToken(`Reclamos/IngresoReclamoExterno`, datos, "POST");
        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Reclamo creado correctamente", 'success', 'Comando Exitoso'))
            dispatch({
                type: types.tomarReclamoIngresado,
                payload: body[0]
            })
            //dispatch(enviarMailReclamo(body[0].id))
            dispatch(TraerReclamoExternoPorId(body[0].id))
            dispatch(finishSpinner());
            
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear el reclamo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const TraerReclamoExternoPorId = (id) => async (dispatch) => {
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamoExternoIdReclamo/${id}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamosTodos,
                payload: body[0]
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const TraerReclamoPorCuit = (cuit) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TraerReclamoExternoPorCuit/${cuit}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamoPorCuit,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const TraerTrackingReclamosExternos = (idReclamo) => async (dispatch) => {

    try {
        const response = await fetchConToken(`Reclamos/TraerTrackingReclamoExterno/${idReclamo}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.trackingReclamos,
                payload: body
            })
        } else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const TraerReclamosEnviadosExternos = ( estado, fechaInicio, fechaFin, cuit, destino, subDestino) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamosEnviadosExternos?estado=${+estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}&cuit=${cuit!==null ? cuit : 0}&destino=${destino !==null ? destino : 0}&subDestino=${subDestino !==null ? subDestino : 0}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamosEnviados,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const generarExcelReclamosEnviadosExternos = (estado, fechaInicio, fechaFin, cuit, destino, subDestino) => async (dispatch) => {

    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    let cuitMod = cuit !== null ? cuit : 0
    let idDestino = destino !== null ? destino : 0
    let idSubDestino = subDestino !==null ? subDestino : 0
    try {
        const response = await fetchConToken(`Reclamos/GenerarExcelReclamosEnviadosExternos/${estado},${fechaInicioMod},${fechaFinMod},${cuitMod},${idDestino},${idSubDestino}`);

        const body = await response.blob();
        if (response.ok) {
            dispatch(finishSpinner());
            let url = window.URL.createObjectURL(body);
            let a = document.createElement('a');
            a.href = url;
            a.download = `ReclamosEnviadosExternos.xlsx`;
            a.click();
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al traer el excel",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }

}

export const TraerReclamosExternos = (estado, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamosExternosTodos?estado=${+estado}&destino=${area}&subDestino=${subArea!==null ? subArea : 0}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamosExternosTodos,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al traer los reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const cambiarEstadoReclamoExterno = (data, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       
       const response = await fetchConToken(`Reclamos/CambiarEstadoReclamoExterno`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(TraerReclamosExternos(estadoSolicitudes, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin));
           dispatch(startAlerta("Cambio realizado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al modificar.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const FetchComentariosExternos = (idReclamo) => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`Reclamos/TraerComentariosExternos/${idReclamo}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.reclamosGetComentariosSolicitudesSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los comentarios de Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const InsertarOrigenErorrReclamoExterno = (data) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       
       const response = await fetchConToken(`Reclamos/OrigenErrorReclamoExterno`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(finishSpinner());
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al insertar el origen del error.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const agregarComentarioExterno = (idReclamo, comentario, idTipoComentario) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idreclamo : idReclamo,
           comentario: comentario,
           idTipoComentario: idTipoComentario
       }
       const response = await fetchConToken(`Reclamos/IngresarComentarioExterno`, data, "POST");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Comentario creado correctamente", 'success', 'Comando Exitoso'));
           dispatch(FetchComentariosExternos(idReclamo))
           dispatch(finishSpinner());
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al crear comentario.", "Ha ocurrido un error. Intente nuevamente")
   }
};


export const finalizarReclamoExterno = (idReclamo, area, subArea,fechaInicio, fechaFin) => async (dispatch) => {

    try {
       dispatch(startSpinner());
       const data = {
        idReclamo : idReclamo
       }
       const response = await fetchConToken(`Reclamos/FinalizarReclamoExterno`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Reclamo finalizado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           dispatch(TraerReclamosExternos(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio, fechaFin))
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al finalizar reclamo.", "Ha ocurrido un error. Intente nuevamente")
   }
};


export const updateDerivacionReclamoExterno = (idReclamo, derivado, subDerivado, areasFisicasUsuario, fechaInicio, fechaFin, descDerivadoA,descSubDerivadoA) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idReclamo : idReclamo,
           derivado: derivado,
           subDerivado: subDerivado !== null ? subDerivado : 0,
           derivadoAnt: descDerivadoA,
           subDerivadoAnt: descSubDerivadoA !== null ? descSubDerivadoA : ""
           


       }
       const response = await fetchConToken(`Reclamos/UpdateDerivacionExterno`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Derivado correctamente", 'success', 'Comando Exitoso'));
           dispatch(TraerReclamosExternos(RECLAMOS_ESTADOS.PENDIENTE, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin))
           dispatch(finishSpinner());
           
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al derivar.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const anularReclamoExterno = (idReclamo, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {

    try {
       dispatch(startSpinner());
       const data = {
           idReclamo : idReclamo
       }
       const response = await fetchConToken(`Reclamos/AnulacionReclamoExterno`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Reclamo anulado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           dispatch(TraerReclamosExternos(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio,fechaFin))
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al anular.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const BuscadorBandejaPorCuitExterno = (cuit, destino, subDestino, estado, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/BuscadorPorCuitExterno?cuit=${+cuit}&destino=${destino}&subDestino=${subDestino!==null ? subDestino : 0}&estado=${estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamosEfectoresTodos,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const BuscadorBandejaPorIdReclamoExterno = (idReclamo, destino, subDestino, estado, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/BuscadorPorIdReclamoExterno?idReclamo=${+idReclamo}&destino=${destino}&subDestino=${subDestino!==null ? subDestino : 0}&estado=${estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamosEfectoresTodos,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

//DOCUMENTACION RECLAMOS

export const getDocumentacionComprobanteReclamoExterno = (idReclamo) =>
    async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConToken(`ReclamosDocumentacionExterno/${idReclamo}`)
            const body = await response.json();
            if (response.ok) {
                dispatch(getDocumentacionReclamosExterno(body));
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            dispatch(errorDocumentacionReclamosExterno());
            handleErrorApi(dispatch, error, "Error al traer documentacion", "Ha ocurrido un error. Intente nuevamente");
        }
    }

export const setDocumentacionReclamoExterno = (formData, idTipoDoc, idReclamo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConTokenFiles(
                `ReclamosDocumentacionExterno/${idTipoDoc}/${idReclamo}`,
                formData,
                "POST",
                dispatch
            );
            const body = await response.json();
            if (response.ok) {
                dispatch(postDocumentacionReclamosExterno(body));
                dispatch(
                    startAlerta(
                        "Datos Guardados Exitosamente",
                        "success",
                        "Comando Exitoso"
                    )
                );
                dispatch(finishSpinner());
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al guardar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
            );
        }
    };
};

export const deleteDocumentoReclamosExterno = (idDocumentacionReclamo) => {
    return async (dispatch) => {
        dispatch(startSpinner());
        try {
            const response = await fetchConToken(
                `ReclamosDocumentacionExterno/${idDocumentacionReclamo}`,
                {},
                "DELETE",
            );
            const body = await response.json();
            if (response.ok) {
                dispatch(deleteDocumentacionReclamosExterno(idDocumentacionReclamo));
                dispatch(finishSpinner());
                dispatch(
                    startAlerta(
                        "Documento Eliminado Exitosamente",
                        "success",
                        "Comando Exitoso"
                    )
                );
            } else {
                throw body;
            }
        } catch (error) {
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al eliminar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
            );
        }
    };
};


export const CambiarCategoriaReclamoExterno = (data, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin) => async (dispatch) => {
    try {
        dispatch(startSpinner());

        const response = await fetchConToken(`Reclamos/CambiarCategoriaReclamoExterno`, data, "POST");
        const body = await response.json();
        if (response.ok) {
            dispatch(TraerReclamosExternos(estadoSolicitudes, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin));
            dispatch(startAlerta("Cambio realizado correctamente", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());

        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al modificar.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const imprimirPDFReclamoExterno = (idSolicitud) => {
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        const response = await fetchConToken(
            `Reclamos/generarPDFReclamoExterno/${idSolicitud}`,
          );
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/pdf") !== -1) {
          const body = await response.blob();
          if (response.ok) {
            dispatch(finishSpinner());
            window.open(URL.createObjectURL(body));
          } else {
            throw body;
          }
        }
        dispatch(finishSpinner());
      } catch (err) {
        console.log(err);
        dispatch(finishSpinner());
        dispatch(
          startAlerta(
            "Ocurrio un error en la generación del PDF",
            "warning",
            `¡Error!`
          )
        );
      }
    };
  };

  export const enviarPDFSolicitudReclamoExterno = (idSolicitud) => {
    return async (dispatch) => {
      try {
        dispatch(startSpinner());
        const response = await fetchConToken(
            `Reclamos/enviarPDFSolicitudExterno/${idSolicitud}`,
          );
        const body = await response.json();
        if (response.status === 200) {
          dispatch(startAlerta(`Mail enviado exitosamente`, 'success', 'Comando Exitoso'));
        } else {
          throw body;
        }
        dispatch(finishSpinner());
      } catch (err) {
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          err,
          "Ocurrio un error en el envío del PDF",
          "Ha ocurrido un error. Intente nuevamente"
        );
      }
    };
  };
  






